import apiClient from "@/services/ApiClient";

export function editActions(path) {
  const getUpdateItemForm = id => apiClient.get(`${path}/${id}`);
  const updateItem = (id, event) => apiClient.put(`${path}/${id}`, event);

  return { getUpdateItemForm, updateItem };
}
